import FirstChart from "../FirstChart/FirstChart";

const Dashboard = () => {

     return (
          <section>
               <FirstChart/>
          </section>
     );
};

export default Dashboard;
